<template>
    <div class="progress-wrapper">
        <div class="bar">
            <i :style="{ width: progress + '%' }"></i>
        </div>
        <ul>
            <li>
                <strong class="num-1"></strong>
                <div>
                    <p>
                        <img
                            src="https://static.web.sdo.com/xyx/pic/act/2025/0825_NewArea/lines/reward-1.png"
                            alt=""
                        />
                        江湖救急包*1
                    </p>
                    <p>
                        <img
                            src="https://static.web.sdo.com/xyx/pic/act/2025/0825_NewArea/lines/reward-2.png"
                            alt=""
                        />初级聚灵珠*1
                    </p>
                    <p>
                        <img
                            src="https://static.web.sdo.com/xyx/pic/act/2025/0825_NewArea/lines/reward-3.png"
                            alt=""
                        />随机石*1
                    </p>
                    <p>
                        <img
                            src="https://static.web.sdo.com/xyx/pic/act/2025/0825_NewArea/lines/reward-4.png"
                            alt=""
                        />生命之水*1
                    </p>
                </div>
            </li>
            <li>
                <strong class="num-2"></strong>
                <div>
                    <p>
                        <img
                            src="https://static.web.sdo.com/xyx/pic/act/2025/0825_NewArea/lines/reward-5.png"
                            alt=""
                        />江湖救急包*1
                    </p>
                    <p>
                        <img
                            src="https://static.web.sdo.com/xyx/pic/act/2025/0825_NewArea/lines/reward-6.png"
                            alt=""
                        />中级聚灵珠*1
                    </p>
                    <p>
                        <img
                            src="https://static.web.sdo.com/xyx/pic/act/2025/0825_NewArea/lines/reward-7.png"
                            alt=""
                        />回城石*1
                    </p>
                    <p>
                        <img
                            src="https://static.web.sdo.com/xyx/pic/act/2025/0825_NewArea/lines/reward-8.png"
                            alt=""
                        />神秘宠物蛋*1
                    </p>
                </div>
            </li>
            <li>
                <strong class="num-3"></strong>
                <div>
                    <p>
                        <img
                            src="https://static.web.sdo.com/xyx/pic/act/2025/0825_NewArea/lines/reward-9.png"
                            alt=""
                        />江湖救急包*1
                    </p>
                    <p>
                        <img
                            src="https://static.web.sdo.com/xyx/pic/act/2025/0825_NewArea/lines/reward-10.png"
                            alt=""
                        />高级聚灵珠*1
                    </p>
                    <p>
                        <img
                            src="https://static.web.sdo.com/xyx/pic/act/2025/0825_NewArea/lines/reward-11.png"
                            alt=""
                        />生命之水*2
                    </p>
                    <p>
                        <img
                            src="https://static.web.sdo.com/xyx/pic/act/2025/0825_NewArea/lines/reward-12.png"
                            alt=""
                        />随机石*1
                    </p>
                </div>
            </li>
            <li>
                <strong class="num-4"></strong>
                <div style="padding-top: 30px">
                    <p>
                        <img
                            src="https://static.web.sdo.com/xyx/pic/act/2025/0825_NewArea/lines/reward-13.png"
                            alt=""
                        />至臻宝石*5
                    </p>
                    <p>
                        <img
                            src="https://static.web.sdo.com/xyx/pic/act/2025/0825_NewArea/lines/reward-14.png"
                            alt=""
                        />高级聚灵珠*2
                    </p>
                    <p>
                        <img
                            src="https://static.web.sdo.com/xyx/pic/act/2025/0825_NewArea/lines/reward-15.png"
                            alt=""
                        />双倍经验卡（3 小时）*1
                    </p>
                    <p>
                        <img
                            src="https://static.web.sdo.com/xyx/pic/act/2025/0825_NewArea/lines/reward-16.png"
                            alt=""
                        />魔神三倍经验卡（3小时）*1
                    </p>
                </div>
            </li>
        </ul>
    </div>
</template>

<script setup>
import { ref, watch } from "vue";

const { counts } = defineProps({
    counts: { type: Number }
});
const progress = ref(0);

watch(
    () => counts,
    (value) => {
        if (value >= 0 && value < 1000) {
            progress.value = 0.016 * value;
        } else if (value >= 1000 && value <= 2000) {
            progress.value = 0.023 * value - 7;
        } else if (value >= 2000 && value <= 5000) {
            progress.value = (23 * value + 71000) / 3000;
        } else if (value > 5000 && value <= 10000) {
            progress.value = 0.0046 * value + 39;
        } else {
            progress.value = 100;
        }
    }
);
</script>

<style lang="scss" scoped>
.progress-wrapper {
    width: 1200px;
    margin: 0px auto 334px auto;
    padding-top: 80px;
    .bar {
        width: 1168px;
        height: 17px;
        margin: 0px auto;
        position: relative;
        background-image: url("https://static.web.sdo.com/xyx/pic/act/2025/0825_NewArea/progress-bar.png");
        i {
            position: absolute;
            height: 100%;
            width: 50%;
            left: 0px;
            top: 0px;
            background-image: url("https://static.web.sdo.com/xyx/pic/act/2025/0825_NewArea/progress-bar-active.png");
            background-repeat: no-repeat;
        }
    }
    ul {
        position: absolute;
        display: flex;
        justify-content: center;
        width: 100%;
        left: 0px;
        top: 320px;
        li {
            margin: 0px 20px;
            strong {
                display: block;
                width: 134px;
                height: 31px;
                margin: 0px auto 70px auto;
                background-repeat: no-repeat;
                &.num-1 {
                    background-image: url("https://static.web.sdo.com/xyx/pic/act/2025/0825_NewArea/num-1.png");
                }
                &.num-2 {
                    background-image: url("https://static.web.sdo.com/xyx/pic/act/2025/0825_NewArea/num-2.png");
                }
                &.num-3 {
                    background-image: url("https://static.web.sdo.com/xyx/pic/act/2025/0825_NewArea/num-3.png");
                }
                &.num-4 {
                    background-image: url("https://static.web.sdo.com/xyx/pic/act/2025/0825_NewArea/num-4.png");
                }
            }
            div {
                width: 229px;
                height: 291px;
                background-image: url("https://static.web.sdo.com/xyx/pic/act/2025/0825_NewArea/progress-item.png");
                margin: 0px auto;
                box-sizing: border-box;
                padding: 40px 54px 0px 54px;
                line-height: 1.4;
                font-size: 15px;
                p {
                    border-bottom: 1px solid rgba(0, 0, 0, 0.3);
                    padding: 5px 0px;
                    display: flex;
                    font-size: 14px;
                    img {
                        width: 24px;
                        height: 24px;
                        margin-right: 4px;
                    }
                    &:nth-last-of-type(1) {
                        border-bottom: none;
                    }
                }
            }
        }
    }
}
</style>
